
import RemoteSelect from '@/components/FormRender/RemoteSelect/RemoteSelect.vue';
import RemoteModal from '@/components/FormRender/RemoteModal/RemoteModal.vue';
import RemoteTreeSelect from '@/components/FormRender/RemoteTreeSelect/RemoteTreeSelect.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FieldRender',
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
    formModel: {
      type: Object,
      default: () => {},
    },
    field_render_show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    model: {
      handler(newValue) {
        this.$emit('update:value', newValue);
      },
    },
    value: {
      handler(newValue) {
        this.model = newValue;
      },
    },
  },
  created() {},
  components: {
    RemoteModal,
    RemoteSelect,
    RemoteTreeSelect,
  },
});
